import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoujjaincab() {



    const cardData = {

keyword: "Mumbai to Ujjain Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Ujjain Cab services for pilgrimage travel, Mahakaleshwar Jyotirlinga darshan, family tours, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving across Maharashtra and Madhya Pradesh routes, we ensure a smooth, comfortable, and hassle-free spiritual journey to Ujjain.",

topPlaces: [
    {
        title: "Shri Mahakaleshwar Jyotirlinga",
        description:
            "Mahakaleshwar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva and the main attraction of Ujjain, known for its powerful Bhasma Aarti and deep spiritual significance."
    },
    {
        title: "Ram Ghat",
        description:
            "Ram Ghat is a sacred bathing ghat on the Shipra River where devotees take holy dips and attend evening aarti during religious festivals like Kumbh Mela."
    },
    {
        title: "Kal Bhairav Temple",
        description:
            "Kal Bhairav Temple is dedicated to the fierce form of Lord Shiva and is famous for its unique ritual where devotees offer liquor as part of worship."
    },
    {
        title: "Harsiddhi Mata Temple",
        description:
            "Harsiddhi Temple is an important Shakti Peeth in Ujjain known for its spiritual importance and beautiful lamp-lit evening rituals."
    },
    {
        title: "Sandipani Ashram",
        description:
            "Sandipani Ashram is believed to be the place where Lord Krishna received his education, making it a highly respected mythological and spiritual site."
    },
    {
        title: "Vedh Shala (Jantar Mantar)",
        description:
            "Vedh Shala is an ancient observatory built by Maharaja Jai Singh II, showcasing India’s historical advancements in astronomy."
    },
    {
        title: "Shipra River Ghats",
        description:
            "The Shipra River Ghats are sacred spots used for rituals, prayers, and religious ceremonies, especially during the Kumbh Mela."
    },
    {
        title: "Mangalnath Temple",
        description:
            "Mangalnath Temple is considered the birthplace of Mars (Mangal Grah) in Hindu mythology and is an important astrological pilgrimage site."
    },
    {
        title: "Gadkalika Temple",
        description:
            "Gadkalika Temple is dedicated to Goddess Kalika and is believed to be associated with ancient scholar Kalidasa."
    },
    {
        title: "Bhartrihari Caves",
        description:
            "Bhartrihari Caves are historical meditation caves located near the Shipra River, known for their spiritual and mythological importance."
    }
],



services: [
{
name: "Mumbai to Ujjain Cab",
description: "Mumbai Airport Cab offers Mumbai to Ujjain Cab service for safe, comfortable, and reliable long-distance pilgrimage travel from Mumbai to the holy city of Ujjain in Madhya Pradesh. Whether you are travelling for Mahakaleshwar Jyotirlinga darshan, family pilgrimage, religious tour, or spiritual journey, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury options. Our experienced chauffeurs ensure smooth highway driving, timely pickup, passenger safety, and a stress-free journey. With doorstep pickup from Mumbai, flexible travel planning, transparent pricing, luggage assistance, and 24x7 support, we make your spiritual journey comfortable and peaceful."
},
{
name: "Mumbai to Ujjain Taxi",
description: "Mumbai to Ujjain Taxi service by Mumbai Airport Cab provides dependable intercity pilgrimage transportation with clean, air-conditioned vehicles and professional chauffeurs. Ideal for families and devotees visiting Mahakal temple, we ensure safe highway travel, punctual pickup, and comfortable seating for a smooth journey from Mumbai to Ujjain."
},
{
name: "Mumbai to Ujjain Cab Fare",
description: "Mumbai to Ujjain Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We provide clear pricing with no hidden charges and flexible options for one-way and round-trip journeys, ensuring cost-effective pilgrimage travel with comfort and reliability."
},
{
name: "Mumbai to Ujjain Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Ujjain Car Rental service with chauffeur-driven vehicles for long-distance spiritual travel. Our fleet includes comfortable sedans and spacious SUVs ideal for family pilgrimage and group tours. We ensure safe driving, luggage support, and flexible itineraries for a smooth travel experience."
},
{
name: "Mumbai to Ujjain One Way Cab",
description: "Mumbai to Ujjain One Way Cab service provides affordable travel for passengers who need a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional chauffeurs for pilgrimage, family visits, and intercity travel."
},
{
name: "Mumbai to Ujjain Outstation Cab",
description: "Mumbai to Ujjain Outstation Cab service offers reliable long-distance transportation with well-maintained vehicles and experienced drivers. Mumbai Airport Cab ensures safe highway driving, flexible schedules, and comfortable seating for stress-free intercity journeys."
},
{
name: "Mumbai to Ujjain Mahakal Cab",
description: "Mumbai to Ujjain Mahakal Cab service is specially designed for devotees visiting Mahakaleshwar Jyotirlinga temple. Mumbai Airport Cab ensures safe travel, smooth highway driving, and comfortable vehicles for a peaceful and divine darshan experience."
},
{
name: "Mumbai to Ujjain Temple Cab",
description: "Mumbai to Ujjain Temple Cab service provides dedicated transportation for pilgrims visiting temples in Ujjain including Mahakal, Kal Bhairav, and other sacred sites. Mumbai Airport Cab ensures reliable service, experienced drivers, and comfortable travel throughout the journey."
},
{
name: "Mumbai to Ujjain Pilgrimage Cab",
description: "Mumbai to Ujjain Pilgrimage Cab service is designed for devotees undertaking spiritual journeys. Mumbai Airport Cab provides comfortable vehicles, experienced chauffeurs, and safe highway travel for a meaningful and peaceful pilgrimage experience."
},
{
name: "Mumbai to Ujjain Family Cab",
description: "Mumbai to Ujjain Family Cab service ensures safe and comfortable transportation for families travelling together for pilgrimage or tourism. Mumbai Airport Cab offers spacious vehicles, luggage-friendly travel, and flexible booking options for stress-free journeys."
},
{
name: "Mumbai to Ujjain Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Ujjain Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality for long-distance spiritual journeys."
},
{
name: "Mumbai to Ujjain SUV Cab",
description: "Mumbai to Ujjain SUV Cab service provides powerful and comfortable vehicles suitable for long highway travel. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth journey experience for families and groups travelling together."
},
{
name: "Mumbai to Ujjain Round Trip Cab",
description: "Mumbai to Ujjain Round Trip Cab service offers complete return journey solutions for pilgrims and tourists. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a smooth round trip experience."
},
{
name: "Mumbai to Ujjain Travel Service",
description: "Mumbai to Ujjain Travel Service provides complete transportation solutions for families, devotees, and tourists. Mumbai Airport Cab ensures safe, comfortable, and well-organized intercity travel with professional drivers and flexible itineraries."
},
{
name: "Mumbai to Ujjain Religious Tour Cab",
description: "Mumbai to Ujjain Religious Tour Cab service offers organized spiritual travel for devotees visiting Mahakaleshwar and other sacred temples. Mumbai Airport Cab ensures comfortable vehicles, experienced drivers, and safe highway travel for a meaningful pilgrimage experience."
},
{
name: "Mumbai to Ujjain Highway Cab",
description: "Mumbai to Ujjain Highway Cab service ensures safe and efficient long-distance travel across major highway routes. Mumbai Airport Cab provides experienced chauffeurs, optimized routes, and well-maintained vehicles for smooth intercity journeys."
},
{
name: "Mumbai to Ujjain Budget Cab",
description: "Mumbai to Ujjain Budget Cab service offers economical travel solutions for pilgrims without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable drivers for cost-effective journeys."
},
{
name: "Mumbai to Ujjain Express Cab",
description: "Mumbai to Ujjain Express Cab service provides fast and efficient transportation for urgent travel needs. Mumbai Airport Cab ensures quick pickup, optimized routes, and professional drivers for timely arrival at your destination."
},
{
name: "Mumbai to Ujjain Night Travel Cab",
description: "Mumbai to Ujjain Night Travel Cab service provides safe overnight transportation for long-distance pilgrims. Mumbai Airport Cab ensures experienced drivers, secure travel conditions, and comfortable vehicles for peaceful night journeys."
}
],

tableData: [
["Mumbai to Ujjain Cab","Mumbai to Ujjain Taxi"],
["Mumbai to Ujjain Cab Fare","Mumbai to Ujjain Car Rental"],
["Mumbai to Ujjain One Way Cab","Mumbai to Ujjain Outstation Cab"],
["Mumbai to Ujjain Mahakal Cab","Mumbai to Ujjain Temple Cab"],
["Mumbai to Ujjain Pilgrimage Cab","Mumbai to Ujjain Family Cab"],
["Mumbai to Ujjain Innova Cab","Mumbai to Ujjain SUV Cab"],
["Mumbai to Ujjain Round Trip Cab","Mumbai to Ujjain Travel Service"],
["Mumbai to Ujjain Religious Tour Cab","Mumbai to Ujjain Highway Cab"],
["Mumbai to Ujjain Budget Cab","Mumbai to Ujjain Express Cab"]
],















whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Ujjain Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Ujjain Cab services for pilgrims, families, tourists, spiritual travelers, and corporate passengers seeking comfortable long-distance transportation."
    },
    {
        WhyChooseheading: "Convenient Mahakal Darshan Journey",
        WhyChoosedescription: "Travel comfortably to Ujjain, one of India's holiest cities and home to the world-famous Shri Mahakaleshwar Jyotirlinga Temple."
    },
    {
        WhyChooseheading: "Perfect for Religious and Spiritual Tours",
        WhyChoosedescription: "Our cab service is ideal for Mahakal Darshan, Omkareshwar Jyotirlinga visits, family pilgrimages, spiritual tours, and customized temple travel packages."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you require a one-way transfer, round trip, multi-day pilgrimage package, or customized itinerary, we provide flexible travel solutions."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced in long-distance interstate routes and ensure safe, comfortable, and hassle-free travel throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Devotees, and Groups",
        WhyChoosedescription: "From individual devotees and families to pilgrimage groups and senior citizens, we provide suitable vehicles for every religious travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do devotees book Mumbai to Ujjain Cabs?",
        answer: "Ujjain is home to the sacred Mahakaleshwar Jyotirlinga and attracts millions of devotees seeking darshan, spiritual blessings, and religious experiences."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Ujjain?",
        answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Ujjain travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Do you provide Mahakal Darshan tour packages?",
        answer: "Yes, customers can book customized pilgrimage packages for Mahakaleshwar Temple and other important religious attractions in Ujjain."
    },
    {
        question: "Can senior citizens travel comfortably to Ujjain?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for elderly passengers, families, and long-distance religious journeys."
    },
    {
        question: "Are Tempo Travellers available for pilgrimage groups?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for religious groups, family tours, and temple pilgrimage trips."
    },
    {
        question: "Can Omkareshwar be included in the same trip?",
        answer: "Yes, customers frequently combine Ujjain Mahakaleshwar Jyotirlinga and Omkareshwar Jyotirlinga Darshan in one customized itinerary."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for Ujjain travel?",
        answer: "Yes, advance booking is recommended, especially during Mahashivratri, Shravan month, weekends, and festival seasons."
    },
    {
        question: "How can I book a Mumbai to Ujjain Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Dinesh Trivedi",
        feedback:
            "Our Mahakal Darshan trip from Mumbai was perfectly arranged. The vehicle was comfortable for the long journey and the driver was very helpful throughout the pilgrimage.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Archana Joshi",
        feedback:
            "We traveled with our family to Ujjain and Omkareshwar. Mumbai Airport Cabs provided excellent service, a clean vehicle, and a smooth travel experience from start to finish.",
        rating: 5
    }
];































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Ujjain Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-ujjain-cab.jpg",
"description": "Book Mumbai to Ujjain cab service for pilgrimage and outstation travel. Mumbai Airport Cabs offers safe and comfortable long-distance taxi service with professional drivers, flexible one-way and round-trip options, and 24x7 availability for temple and family journeys.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-ujjain-cab"
}
};





    return (
        <div>




<Helmet>
  <title>Mumbai to Ujjain Cab | Pilgrimage Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Ujjain cab for pilgrimage and outstation travel. Safe and comfortable taxi service with professional drivers, flexible one-way and round-trip options, and 24x7 availability."
/>

<meta
 name="keywords"
 content="mumbai to ujjain cab, mumbai to ujjain taxi, mumbai to ujjain cab fare, mumbai to ujjain car rental, mumbai to ujjain one way cab, mumbai to ujjain outstation cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoujjaincab;